// extracted by mini-css-extract-plugin
export var layoutContainer = "_bm-0";
export var layoutContainerNoRounding = "_bm-6";
export var layoutContainerOpen = "_bm-5";
export var layoutContainerResizing = "_bm-1";
export var mainContent = "_bm-2";
export var resizeDivider = "_bm-3";
export var slidePanel = "_bm-4";